import * as React from 'react';
import {
    FilterButton,
    SearchInput,
    SelectInput,
    FilterForm,
    Button,
    useListContext,
} from 'react-admin';
import { Box, Stack, SxProps, Theme } from '@mui/material';
import { useMissionTypes } from '@app/mission_type/useMissionType';

export const AnimationListFilter = ({
    disableSaveQuery,
    sx,
}: {
    disableSaveQuery?: boolean;
    sx?: SxProps<Theme>;
}) => {
    const { setFilters, filterValues } = useListContext();
    const { data: missionTypes = [] } = useMissionTypes();

    const animationFilters = [
        <SearchInput
            key="search"
            source="search"
            alwaysOn
            placeholder="Search name, description..."
        />,
        <SelectInput
            key="enabled"
            source="enabled"
            label="Status"
            alwaysOn
            choices={[
                { id: true, name: 'Enabled' },
                { id: false, name: 'Disabled' },
            ]}
        />,
        <SelectInput
            key="missionType"
            source="missionType"
            label="Mission type"
            alwaysOn
            choices={missionTypes.map(t => ({ id: t.id, name: t.name }))}
        />,
    ];

    const hasFilters = filterValues && Object.keys(filterValues).length > 0;

    const handleClearFilters = () => {
        setFilters({});
    };

    return (
        <Box minWidth="10em" maxWidth="18em" order={-1} mr={2} sx={sx}>
            <Stack flexDirection={'row'} justifyContent={'space-between'}>
                <FilterButton
                    filters={animationFilters}
                    disableSaveQuery={disableSaveQuery}
                />
                <Button
                    disabled={!hasFilters}
                    label="Clear all"
                    onClick={handleClearFilters}
                    variant="outlined"
                    size="small"
                />
            </Stack>
            <FilterForm filters={animationFilters} />
        </Box>
    );
};
